import { getBranchOfficeByCarLots } from './getBranchOfficesByCarLots'

export const SoliVenta = {
    getBranchOfficeByCarLots
}